module.exports = __webpack_public_path__ + "img/provider13.8c293026.png";